export default __webpack_public_path__ + "static/media/Utoronto_coa.svg.8de741e4.png";